module.exports = __webpack_public_path__ + "img/77ce6bc446f76cc2503c546f84319cf5.svg";